<template><!--选择菜场-->
    <div class="app">
        <jycheader></jycheader>
        <div class="choose-city-box">
            <div class="choose-city-banner">
                <img
                    style="width:100%;height:auto"
                    src="../../assets/image/img/newimg/qwe.png"
                    alt=""
                />
            </div>
            <div
                class="dis-cen"
                style="background-color: #F1F1F1;"
            >
                <div style="height:20px"></div>
                <div class="dis wid-bac">
                    <div class="wid-tab" :class="tab_num == 2?'act-bac':''" @click="tabClick(2)" style="cursor:pointer">收货地址</div>
                    <div class="wid-tab" :class="tab_num == 1?'act-bac':''" @click="tabClick(1)" style="cursor:pointer" v-if="!isSetOneAddress">选择菜场</div>
                </div>
                <div style="min-height:10rem;width:1000px">
                    <div v-if="tab_num == 1" class="dis" style="width:100%">
                        <div v-for="(item, index) in marketList" style="width:28%;margin:24px 25px;background-color:#ffffff" @click="marketClick(index, item.id)">
                            <div class="dis-between marketlistbut" style="width:100%;cursor:pointer;">
                                <div style="width:88%;">
                                    <div v-if="item.status == 1" style="margin-top:-4px">
                                        <img style="height:20px" src="../../assets/image/img/346.png" />
                                        <div style="font-size: 8px;color:#ffffff;margin-top:-23px;margin-left:23px" >已签约</div>
                                    </div>
                                    <div v-else style="margin-top:-4px">
                                        <img style="height:20px" src="../../assets/image/img/345.png" />
                                        <div style="font-size: 8px;color:#ffffff;margin-top:-23px;margin-left:23px" >未签约</div>
                                    </div>
                                    <div style="padding:5px 0 12px 12px">
                                        <div style="font-size:18px;margin:5px 0 ">{{item.name}}</div>
                                        <div style="font-size:14px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;">{{item.address}}</div>
                                    </div>
                                </div>
                                <img style="width:34px;height:33px;margin-top:50px" v-if="item.id == act_id" src="../../assets/image/img/newimg/dagou.png" />
                            </div>
                        </div>
                        <div v-if="isShowLoading" class="nodata">加载中...</div>
                        <div v-else-if="marketList.length == 0" class="nodata">请先选择收货地址</div>
                    </div>
                    <div v-else>
                        <div class="dis-end"><div style="color:#11D165;cursor:pointer" @click="addPopupClick">添加收货地址</div></div>
                        <div v-if="addressList.length > 0">
                            <div v-for="(item2, index2) in addressList" style="width:100%;margin:24px 25px;background-color:#ffffff">
                                <div class="dis-between marketlistbut" style="width:100%;cursor:pointer;">
                                    <div style="width:86%;padding:5px 0 12px 12px" @click="addressListClick(index2, item2.id)">
                                        <div class="dis"><div style="font-size:18px;margin:5px 0 ">{{item2.lngLatAddress}}</div><div v-if="item2.isDefault" style="padding:0 8px;height:24px;line-height:24px;margin:auto 10px;font-size:12px;background-color:rgb(17, 209, 101);color:#ffffff;border-radius:20px">默认</div></div>
                                        <div class="dis" style="font-size:14px;margin-bottom:5px">{{item2.userName}}&nbsp;&nbsp;{{item2.phone}}</div>
                                        <div style="font-size:14px;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;">{{item2.address}}</div>
                                    </div>
                                    <div class="dis-end">
                                        <div class="dis" style="margin:10px 0 0 0;height:19px">
                                            <div style="color:rgb(17, 209, 101);cursor:pointer" @click="editClick(index2,item2)">编辑</div>
                                            <div style="width:1px;height:16px;background-color:#484848;margin:4px 20px 0 20px"></div>
                                            <div style="color:#f56c6c;cursor:pointer" @click="delAddress(item2.id)">删除</div>
                                        </div>
                                        <img style="width:34px;height:33px;margin-top:62px" v-if="item2.id == addressId" src="../../assets/image/img/newimg/dagou.png" />
                                        <div style="width:34px" v-else></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="isShowLoading" class="nodata">加载中...</div>
                        <div v-else-if="addressList.length == 0" class="nodata">暂无数据</div>
                        <el-dialog title="提示" :visible.sync="centerDialogVisible" width="30%" center>
                            <span>确定删除当前地址吗?</span>
                            <span slot="footer" class="dialog-footer">
                                <el-button @click="centerDialogVisible = false">取 消</el-button>
                                <el-button type="primary" @click="delete_ok()">确 定</el-button>
                            </span>
                        </el-dialog>
                    </div>
                </div>
            </div>
        </div>
        <jycfooter></jycfooter>
        <address-popup v-if="is_popup" :parent-name="addressData" @childFn="closePopup"></address-popup>
    </div>
</template>

<script>
    import jycheader from "../header.vue"
    import jycfooter from "../bottom.vue"
    import AddressPopup from './insidePages/addressPopup.vue'

    export default
    {
        data()
        {
            return {
                tab_num: 1,
                addressList: [],
                addressId: -1,
                marketList: [],
                act_id: -1,
                is_popup: false,
                addressData: {},
                isSetOneAddress: false,
                isShowLoading: false,
                centerDialogVisible: false, //删除地址提示框状态
                del_id: -1,
            }
        },
        components:
        {
            jycheader,
            jycfooter,
            AddressPopup
        },
        created()
        {
            if ( !localStorage.getItem('token') )
            {
                this.$confirm( '此操作需要登录, 是否前往登录?', '提示',
                {
                    confirmButtonText: '确定',
                    // cancelButtonText: '取消',
                    showCancelButton: false,
                    showClose: false,
                    closeOnClickModal: false,
                    type: 'warning'
                } ).then( () =>
                {
                    this.$router.push({path: '/login'})
                } ).catch( () =>
                {
                    // ...
                } )
                return
            }

            let num = this.$route.query.num
            if (localStorage.getItem( 'isSetOneAddress' )) this.isSetOneAddress = true
            this.tab_num = num
            this.init()

        },
        methods:
        {
            delAddress(id) {
                this.del_id = id
                //删除地址
                this.centerDialogVisible = true
            },
            delete_ok() {
                //用户确认删除当前地址
                this.$api.order.delAddress(this.del_id).then(res => {
                    if (res.data.code == 0) {
                        let name = "删除成功!"
                        this.checkTips(name, "success")
                        this.centerDialogVisible = false
                        this.addressList= []
                        this.addressId= -1
                        this.init()
                    } else {
                        let name = res.data.message
                        this.checkTips(name, "warning")
                    }
                })
            },
            addPopupClick() {
                this.is_popup = true
            },
            editClick(idx, obj) {
                this.addressData = obj
                this.is_popup = true
            },
            closePopup(bol) {
                this.addressData = {}
                this.is_popup = bol
                let params = { PageSize: 100, PageNo: 1 }
                this.$api.order.getAddress(params).then(res => {
                    if (res.data.code == 0) {
                        let AddressActObj = JSON.parse(localStorage.getItem('AddressActObj'))
                        this.addressList = res.data.result.data
                        this.act_id = AddressActObj.id
                    } else {
                        let name = res.data.message
                        this.checkTips(name, "warning")
                    }
                })
            },
            tabClick(val) {
                this.tab_num = val
                this.init()
                if (val == 1) {
                    if (!localStorage.getItem('marketActObj')) return
                    let marketActObj = JSON.parse(localStorage.getItem('marketActObj'))
                    this.act_id = marketActObj.id
                } else {
                    if (!localStorage.getItem('AddressActObj')) return
                    let AddressActObj = JSON.parse(localStorage.getItem('AddressActObj'))
                    this.act_id = AddressActObj.id
                }
            },
            marketClick(idx, val) {
                this.act_id = val
                let that = this
                let a = this.marketList[idx]
                localStorage.setItem('marketActObj', JSON.stringify(a))
                this.$message(
                {
                    type: 'success',
                    message: '当前菜场：' + a.name
                } );
                setTimeout(function(){
                    that.$router.push( { path: '/' } )
                }, 1000)
            },
            addressListClick(idx, val) {
                this.addressId = val
                let that = this
                let a = this.addressList[idx]
                localStorage.setItem('AddressActObj', JSON.stringify(a))
                let b = { twoId: a.city, twoName: a.cityName, threeId: a.region, threeName: a.regionName, LngLatAddress: a.lngLatAddress }
                localStorage.setItem( "cityname", JSON.stringify( b ) )
                // +---------------------------------------------------
                // this.$api.order.setdefaultAddress(val).then(res => {
                //     if (res.data.code == 0) {
                        this.$message(
                        {
                            type: 'success',
                            message: '当前收货地址：' + a.lngLatAddress
                        } );
                        setTimeout(function(){
                            window.localStorage.removeItem('marketActObj');
                            if (that.isSetOneAddress) {
                                that.$router.push( { path: '/' } )
                                return
                            }
                            that.tab_num = 1
                            that.act_id = -1
                            that.init()
                        }, 1000)
                //     } else {
                //         let name = res.data.message
                //         this.checkTips(name, "warning")
                //     }
                // })
            },
            init() {
                let arr = []
                let addressObj = {}
                let msgShow = ''
                if (!JSON.parse(localStorage.getItem('AddressActObj'))) {
                    let addressListData = JSON.parse( localStorage.getItem( 'v_addressListData' ) )
                    if (!addressListData) return
                    for (let i = 0; i < addressListData.length; i++) {
                        if (addressListData[i].isDefault) {
                            arr.push(addressListData[i])
                        }
                    }
                    if (arr.length > 0) {
                        addressObj = arr[0]
                    } else {
                        addressObj = addressListData[0]
                    }
                    localStorage.setItem('AddressActObj', JSON.stringify(addressObj))
                    let a = { twoId: addressObj.city, twoName: addressObj.cityName, threeId: addressObj.region, threeName: addressObj.regionName, LngLatAddress: addressObj.lngLatAddress }
                    localStorage.setItem( "cityname", JSON.stringify( a ) )
                    
                    msgShow = '已关联默认地址：' + addressObj.lngLatAddress
                    if (this.tab_num == 2) this.checkTips(msgShow, "warning")
                }
                addressObj = JSON.parse(localStorage.getItem('AddressActObj'))
                this.addressId = addressObj.id
                // +-----------------------------
                if (this.tab_num == 1) {
                    this.isShowLoading = true
                    let inputData = {LngLat:addressObj.lngLat, CityId:addressObj.city, RegionId:addressObj.region, type:addressObj.type}
                    this.$api.order.GetMarkets(inputData).then(res => {
                        this.isShowLoading = false
                        if (res.data.code == 0) {
                            console.log(res.data.result)
                            let marketActObj = JSON.parse(localStorage.getItem('marketActObj'))
                            this.marketList = res.data.result
                            if (!marketActObj) {
                                this.checkTips('选择菜场', "warning")
                                return
                            }
                            this.act_id = marketActObj.id
                        } else {
                            let name = res.data.message
                            this.checkTips(name, "warning")
                        }
                    })
                } else {
                    this.isShowLoading = true
                    let params = { PageSize: 100, PageNo: 1 }
                    this.$api.order.getAddress(params).then(res => {
                        this.isShowLoading = false
                        if (res.data.code == 0) {
                            let AddressActObj = JSON.parse(localStorage.getItem('AddressActObj'))
                            this.addressList = res.data.result.data
                            this.act_id = AddressActObj.id
                            // [补充] +------------------------------
                            let checkValue = ''
                            for (let i = 0; i < this.addressList.length; i++) {
                                if (this.addressList[i].id == this.act_id) checkValue = 1
                            }
                            if (!checkValue) {
                                localStorage.removeItem('AddressActObj')
                                localStorage.removeItem('marketActObj')
                                localStorage.removeItem('v_addressListData')
                                this.marketList = []
                                this.act_id = -1
                                let cityname = JSON.parse(localStorage.getItem('cityname'))
                                cityname.LngLatAddress = ''
                                localStorage.setItem( "cityname", JSON.stringify( cityname ) )
                                this.checkTips('请先选择收货地址', "warning")
                            }
                        } else {
                            let name = res.data.message
                            this.checkTips(name, "warning")
                        }
                    })
                }
            },
            checkTips( name, type )
            {
                this.$message(
                {
                    message: name,
                    type: type
                } );
            },
            
        },
        beforeDestroy(){
          localStorage.removeItem( 'isSetOneAddress' )
        }
    }
</script>



<style scoped="scoped">
    @import '../../assets/style/base.css';


    .marketlistbut{
        transition-duration: 0.4s;
    }

    .marketlistbut:hover {
		-webkit-box-shadow: #ccc 200px 20px 20px;
		-moz-box-shadow: #ccc 10px 10px 10px;
		box-shadow: #ccc 10px 10px 10px;
		-webkit-transform: translate(0px, -5px);
		-moz-transform: translate(5px, 5px);
		background-color: #FFFFFF;
		cursor: pointer;
	}

    .header_input {
        margin: 50px 0 80px 0
    }
    .wid-bac{width:30.4rem;height:2.5rem;padding:0.2rem 0.2rem;background-color:#ffffff;border-radius:30rem;margin:10px}
    .wid-tab{width:15rem;height:2.1rem;color:#11D165;border-radius: 30rem;text-align: center;line-height: 2.1rem;font-size: 15px;}
    .input-box-inputbox {
        width: 29.0625rem;
        height: 2.5rem;
        border: 2px solid #11D165;
        border-radius: 5px 0 0 5px;
        outline: none;
        padding-left: 1rem;
    }

    .choose-box-city>>>.el-button {
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        background: #F7F7F7;
        border: none;
        color: #434343;
        -webkit-appearance: none;
        text-align: center;
        box-sizing: border-box;
        outline: 0;
        margin: 0;
        transition: .1s;
        font-weight: 500;
        padding: 12px 20px;
        font-size: 16px;
        border-radius: 4px;
    }

    .act-color {
        color: #11D165
    }
    .act-bac {
        background-color: #11D165;color: #ffffff;
    }
    .exist-color {
        color: #f76805
    }

    .header_input>img {
        margin-right: 6px;
    }

    .header_input span {
        color: #404040;
        font-size: 18px;
        margin-right: 6px;
        font-weight: 400;
        cursor: pointer;
    }

    .header_inputs {
        width: 4.8125rem;
        height: 2.5rem;
        background: #11D165;
        border-radius: 0 3px 3px 0;
        cursor: pointer;
        color: #ffffff;
        font-size: 1rem;
        text-align: center;
        line-height: 2.5rem;
    }
    .nodata{
        width:100%;
        text-align: center;
        line-height: 10rem;
    }

    .search-hot {
        width: 33.875rem;
        margin: 0.5rem 0 0 0;
        color: #666666;
        font-size: 12px;
        font-weight: 400;
    }
</style>